import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
import { MOCKUP_IMAGE } from '../../data/offer';
export function Hero() {
  const mockup = <img src={MOCKUP_IMAGE} alt="Hair Transplant Blueprint™ collection: six educational volumes and five complementary bonuses." className="mx-auto w-full max-w-[560px]" data-id="element-179" data-mp="cvbejhngf7nv" />;
  return <header className="w-full bg-ink text-white" data-id="element-180" data-mp="mutwjsjt0jda">
      <div className="bg-navy-2 px-4 py-2.5 text-center text-xs font-semibold uppercase tracking-wider text-white/80 md:text-sm" data-id="element-181" data-mp="mrxwnyoebkm7">
        By Dr. Daniel Mitchell · Hair Restoration Education
      </div>
      <div className="mx-auto max-w-6xl px-4 pb-16 pt-8 md:pt-14 lg:grid lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-12" data-id="element-182" data-mp="voosc9z1cxg9">
        <div className="text-center lg:text-left" data-id="element-183" data-mp="15l1wk1s7itp9">
          <p className="font-display text-sm font-extrabold uppercase tracking-wide text-gold md:text-base" data-id="element-184" data-mp="15mcxzuy6jpd7">
            The complete Hair Transplant Blueprint™ is here
          </p>
          <h1 className="mt-3 font-display text-[46px] font-black uppercase leading-[0.92] tracking-tight md:text-7xl" data-id="element-185" data-mp="9om18jfz0gs4">
            Hair Transplant <span className="block text-cyan" data-id="element-186" data-mp="4r2k9brw1pwh">Blueprint™</span>
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-balance text-[15px] font-bold uppercase tracking-wide text-white/85 md:text-lg lg:mx-0" data-id="element-187" data-mp="3vvaq89gw27c8">
            A structured educational reference system for hair restoration professionals
          </p>

          <div className="-mx-2 mt-6 lg:hidden" data-id="element-188" data-mp="nfh7dnz34js0">{mockup}</div>

          <p className="mx-auto mt-6 max-w-xl text-[17px] leading-relaxed text-white/75 md:text-lg lg:mx-0" data-id="element-189" data-mp="nhaj3hok1u6v">
            Bring your hair transplant references, patient assessment resources, anatomical study materials, and clinical
            documentation tools together in one organized educational collection.
          </p>

          <div className="mx-auto mt-6 grid max-w-xl grid-cols-2 gap-3 lg:mx-0" data-id="element-190" data-mp="16ebr7bdeoaf1">
            <div className="flex items-center gap-3 rounded-2xl bg-navy-2 p-3 text-left" data-id="element-191" data-mp="16c8obqr5mmsw">
              <BookOpenIcon className="h-7 w-7 shrink-0 text-cyan" aria-hidden="true" data-id="element-192" data-mp="30o0czkm5fge3" />
              <p className="font-display text-sm font-extrabold uppercase leading-tight" data-id="element-193" data-mp="35k8mahdo0fdc">
                <span className="block text-2xl text-cyan" data-id="element-194" data-mp="2qvktujz48lrm">6</span>Specialized volumes
              </p>
            </div>
            <div className="flex items-center gap-3 rounded-2xl bg-navy-2 p-3 text-left" data-id="element-195" data-mp="2vt4crx6rdmpw">
              <GiftIcon className="h-7 w-7 shrink-0 text-gold" aria-hidden="true" data-id="element-196" data-mp="2hxipbug6bazl" />
              <p className="font-display text-sm font-extrabold uppercase leading-tight" data-id="element-197" data-mp="2mw3pjtvfduo1">
                <span className="block text-2xl text-gold" data-id="element-198" data-mp="27yjmwtm04bl1">5</span>Exclusive bonuses
              </p>
            </div>
          </div>

          <div className="mt-8" data-id="element-199" data-mp="2cy62vat7s5xj">
            <p className="text-sm font-bold uppercase tracking-wide text-white/70" data-id="element-200" data-mp="65dayo5idhgg">Your complete collection today</p>
            <p className="mt-1 font-display text-5xl font-black text-white md:text-6xl" data-id="element-201" data-mp="b3x2d42vflg7">
              Just <span className="text-gold" data-id="element-202" data-mp="1vo278d7gp7n1">$27</span> <span className="text-2xl md:text-3xl" data-id="element-203" data-mp="1vkxu2qc0r1k8">USD</span>
            </p>
          </div>

          <div className="mt-6 lg:[&>div]:items-start" data-id="element-204" data-mp="1qpqvty1iqp2p">
            <CTAButton id="hero-cta" label="Get the Hair Transplant Blueprint™" sub="Digital product · One-time payment · No recurring subscription" data-id="element-205" data-mp="25d3jbsavz4vq" />
          </div>
        </div>

        <div className="hidden lg:block" data-id="element-206" data-mp="2ebxfxio7vv9a">{mockup}</div>
      </div>
    </header>;
}